import React, { Component, CSSProperties, ReactElement } from 'react';
import Style from './index.less';
import Dropdown from '@tencent/dui/lib/components/Dropdown';
import Tooltip from '@tencent/dui/lib/components/Tooltip';
import { DROPDOWN_ICON } from '@src/framework/workbench/drawer/image';
import { getTooltipProps } from './index';

type IFontDropdownState = {
    text?: string;
};

type IFontDropdownProps = {
    text?: any;
    dropContent: ReactElement;
    style?: CSSProperties
    fontDropContentStyle?: CSSProperties;
    fontDropStyle?: CSSProperties;
    tooltip?: any;
};

export default class FontDropdown extends Component<IFontDropdownProps, IFontDropdownState> {
    public static getDerivedStateFromProps(props, state) {
        // 有更新的时候再刷新
        if (state.text !== props.text) {
            return {
                text: props.text,
            };
        }
        return null;
    }

    public constructor(props) {
        super(props);
        this.state = {
            text: this.props.text,
        };
    }

    public render() {
        return (
            <Dropdown
                style={this.props.fontDropStyle}
                dropContent={this.props.dropContent}
                dropContentStyle={this.props.fontDropContentStyle}
            >
                <Tooltip {...getTooltipProps(this.props.tooltip)}>
                    <div className={Style['border-arrow-dropdown-wrapper']} style={this.props.style}>
                        <div className={Style['border-arrow-text']}>
                            {this.state.text}
                        </div>
                        <div className={Style['border-arrow-dropdown-icon']}>
                            <img src={DROPDOWN_ICON} alt={''}></img>
                        </div>
                    </div>
                </Tooltip>
            </Dropdown>
        );
    }
}
